import { __assign } from "tslib";
import { createRoutingRulesApi } from './index';
import { createHttpTestKit } from '../http/test-kit';
import { createFakeGetResponder, createFakePostResponder } from '../test-utils';
export var createRoutingRulesApiTestKit = function () {
    var fakeHttp = createHttpTestKit();
    var api = createRoutingRulesApi('', fakeHttp);
    var testKit = {
        whenGetByTargetGroupIds: function (dto) { return createFakePostResponder(fakeHttp, "/routing-rules/groups")(dto); },
        whenGetAll: function () { return createFakeGetResponder(fakeHttp, "/routing-rules"); },
    };
    return __assign(__assign({}, api), testKit);
};
//# sourceMappingURL=testkit.js.map